<template>
    <div class="tinymce-textarea">
        <editor
            :init="tinymceConfig"
            :api-key="tinymceConfig.api_key"
            :retain-focus="false"
            v-model="context.model"
            eager
        >
        </editor>
    </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import common from '@/components/sme/mixins/common';

export default {
    name: 'FormulateTinymce',
    inheritAttrs: false,
    mixins: [common],
    components: {
        Editor,
    },
    props: {
        context: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            tinymceConfig: {
                height: 200,
                toolbar: 'paragraph bold italic underline image numlist bullist alignleft aligncenter alignright link code ',
                api_key: ca.tinymce.api_key,
                indent: false,
                plugins: ['autolink lists link anchor paste code help wordcount image'],
            },
        }
    },
}
</script>